export default {
  hello: { en: "Hello", tr: "Merhaba", ru: "Здравствуйте" },
  "TECHNICAL SPECIFICATIONS": {
    en: "TECHNICAL SPECIFICATIONS",
    tr: "TEKNIK DETAYLAR",
    ru: "ТЕХНИЧЕСКИЕ ХАРАКТЕРИСТИКИ",
  },
  SUMMARY: {
    en: "SUMMARY",
    tr: "ÖZET",
    ru: "РЕЗЮМЕ",
  },
  BUILDS: {
    en: "BUILDS",
    tr: "Konfigurasyonlar",
    ru: "КОНФИГУРАЦИИ",
  },
  SERVICE: {
    en: "SERVICE",
    tr: "SERViS",
    ru: "СЕРВИС",
  },
  SELECT_INFO: {
    en: "*Manufacturer’s Suggested Retail Price (MSRP), excludes options, taxes, title and registration processing.",
    tr: "",
    ru: "*Рекомендованная розничная цена производителя (MSRP), не включает опции, налоги, регистрацию и оформление.",
  },
  Length: {
    en: "Length",
    tr: "Boy",
    ru: "Длина",
  },
  Beam: {
    en: "Beam",
    tr: "Genişlik",
    ru: "Ширина",
  },
  "Beam with open Side Teracces": {
    en: "Beam with open Side Teracces",
    tr: "Açık teras genişliği",
    ru: "Ширина с открытыми боковыми террасами",
  },
  Draft: {
    en: "Draft",
    tr: "Draft",
    ru: "Осадка",
  },
  Displacement: {
    en: "Displacement",
    tr: "Displacement",
    ru: "Водоизмещение",
  },
  Passengers: {
    en: "Passengers",
    tr: "Kapasite",
    ru: "Пассажиры",
  },
  Berths: {
    en: "Berths",
    tr: "Berth",
    ru: "Спальные места",
  },
  "Fuel Cap": {
    en: "Fuel Cap.",
    tr: "Yakıt kap.",
    ru: "Топливный бак",
  },
  Range: {
    en: "Range",
    tr: "Menzil",
    ru: "Дальность",
  },
  "Fresh Water Cap": {
    en: "Fresh Water Cap",
    tr: "Su kapasitesi",
    ru: "Запас пресной воды",
  },
  Classification: {
    en: "Classification",
    tr: "Sınıf",
    ru: "Классификация",
  },
  "ENGINE TYPES": {
    en: "ENGINE TYPES",
    tr: "MOTOR SEÇENEKLERİ",
    ru: "ТИПЫ ДВИГАТЕЛЕЙ",
  },
  "Engine Type": {
    en: "Engine Type",
    tr: "Motor Tipi",
    ru: "Тип двигателя",
  },
  Propulsion: {
    en: "Propulsion",
    tr: "İtme",
    ru: "Движение",
  },
  "Fuel Type": {
    en: "Fuel Type",
    tr: "Yakıt Tipi",
    ru: "Тип топлива",
  },
  Engines: {
    en: "Engines",
    tr: "Motorlar",
    ru: "Двигатели",
  },
  Speed: {
    en: "Speed",
    tr: "Hız",
    ru: "Скорость",
  },
  "EXTRA INCLUDED": {
    en: "EXTRA INCLUDED",
    tr: "EKSTRALAR",
    ru: "ДОПОЛНИТЕЛЬНО ВКЛЮЧЕНО",
  },
  "STANDARD FEATURES": {
    en: "STANDARD FEATURES",
    tr: "STANDART ÖZELLİKLER",
    ru: "СТАНДАРТНЫЕ ФУНКЦИИ",
  },
  "STANDARD SPECIFICATIONS": {
    en: "STANDARD SPECIFICATIONS",
    tr: "STANDARD SPESİFİKASYONLAR",
    ru: "СТАНДАРТНЫЕ ХАРАКТЕРИСТИКИ",
  },
  STANDARD_INFO: {
    en: `Specifications are based on available information at the time. Actual specifications may vary. [name] reserves the right to change product line specifications, equipment, color scheme and pricing, or to discontinue models at any time without notice or obligation.`,
    tr: `Spesifikasyonlar, o sırada mevcut olan bilgilere dayanmaktadır. Özellikler değişebilir. [name] herhangi bir zamanda bildirimde bulunmaksızın veya herhangi bir yükümlülük altına girmeksizin ürün hattı özelliklerini, ekipmanı, renk şemasını ve fiyatlandırmayı değiştirme veya modelleri durdurma hakkını saklı tutar.`,
    ru: `Характеристики основаны на доступной информации на данный момент. Фактические характеристики могут отличаться. [name] оставляет за собой право изменять характеристики продукции, оборудование, цветовую гамму и цены, а также снимать модели с производства в любое время без уведомления и обязательств.`,
  },
  "PURCHASE PRICE": {
    en: "PURCHASE PRICE",
    tr: "SATIŞ FİYATI",
    ru: "ЦЕНА ПОКУПКИ",
  },
  PRICE: {
    en: "OPTIONS PRICE",
    tr: "OPSİYONLARIN TOPLAM FİYATI",
    ru: "ЦЕНА ОПЦИЙ",
  },
  Power: {
    en: "Power",
    tr: "Motor Gücü",
    ru: "Мощность",
  },
  SELECT_YOUR: {
    en: "[name] Configurator",
    tr: "[name] Konfigurator",
    ru: "Конфигуратор [name]",
  },
  "Transportation Fee": {
    en: "TRANSPORTATION / HANDLING / DELIVERY COSTS",
    tr: "NAKLİYE / TAŞIMA / TESLİMAT MALİYETLERİ",
    ru: "ТРАНСПОРТИРОВКА / ОБРАБОТКА / ДОСТАВКА",
  },

  "Total Price": {
    en: "Total Price",
    tr: "Toplam Fiyat",
    ru: "Общая цена",
  },

  TRANSPORTATION_INFO: {
    en: `
<b>*Istanbul Kalamış Marina Turnkey Delivery Service</b>
<br /></br />
This service covers the transportation process from the shipyard in Poland to Istanbul, as well as all critical procedures carried out before delivery.
<br /><br />
Service Scope:

<br /><br />
Transport Preparation & Shipping: Cradle and shrink wrap protection, crane rental, labor costs<br />
Customs & Permits: Road tolls, special road permits between Poland and Turkey, export expenses<br />
Freight Insurance & Customs Clearance<br /><br />
Pre-Delivery Process in Istanbul:

<br /><br />
One week of quality control and installation of additional options.<br />
Three days of sea trials with marina accommodation services.<br />
Machine start-up and launching (lift fees included).<br />
Commissioning of Simrad & Mastervolt systems.<br />
Fuel for sea trials (100L) and test run expenses.<br />
Every detail is meticulously managed for a seamless and hassle-free delivery process.<br />
`,
    tr: `
<b>*İstanbul Kalamış Marina Anahtar Teslim Hizmeti</b>
<br /><br />
Bu hizmet, Polonya’daki tersaneden İstanbul’a kadar olan nakliye sürecini ve teslimat öncesi gerçekleştirilen tüm önemli işlemleri kapsamaktadır.<br /><br />

Süreç, nakliye hazırlığı ve yükleme aşamasıyla başlar. Teknenin güvenli taşınmasını sağlamak için cradle ve shrink wrap gibi koruyucu önlemler uygulanır. Nakliye sırasında vinç kiralama ve işçilik maliyetleri dikkate alınarak, taşıma süreci eksiksiz bir şekilde yönetilir. Ayrıca, öngörülemeyen yol harçları, Polonya-Türkiye arasında özel yol izinleri ve ihracat masrafları da hizmet kapsamına dahildir. Nakliyat sigortası ve gümrük işlemleri ise sürecin ayrılmaz bir parçasıdır.<br /><br />

İstanbul’a varışın ardından, tekne 1 hafta boyunca kalite kontrol ve ek opsiyonların montajı için hazırlanır. Ardından, 3 gün süren deniz testleri gerçekleştirilir ve bu süreç boyunca marina konaklama hizmetleri sağlanır. Ayrıca, makine start-up işlemleri ve denize indirme lift ücretleri bu hizmete dahildir. Simrad ve Mastervolt gibi elektronik sistemlerin devreye alınması sağlanırken, deniz testleri için gerekli yakıt (100lt) ve test sürüşü masrafları da karşılanarak kapsamlı bir teslimat süreci sunulmaktadır.
`,
  },

  From: {
    en: "from",
    tr: "başlangıç fiyatı",
    ru: "от",
  },
  "CONFIGURE YOUR": {
    en: "CONFIGURE YOUR [name]",
    tr: "[name] OLUŞTURUN",
    ru: "НАСТРОЙТЕ СВОЙ [name]",
  },
  "ORDER SUMMARY": {
    en: "ORDER SUMMARY",
    tr: "SİPARİŞ ÖZETİ",
    ru: "СВОДКА ЗАКАЗА",
  },
  "SEND PDF": {
    en: "SEND PDF",
    tr: "PDF GÖNDER",
    ru: "ОТПРАВИТЬ PDF",
  },
  "ENTER YOUR DETAILS": {
    en: "ENTER YOUR DETAILS",
    tr: "KİŞİSEL BİLGİLER",
    ru: "ВВЕДИТЕ ВАШИ ДАННЫЕ",
  },
  SUMMARY_INFO: {
    en: "*Purchase Price including selected options & delivery but excludes taxes, title and registration processing.",
    tr: "*Satış fiyatı seçilenleri ve transferi içerir. Vergiler ve kayıt ücretleri dahil değildir.",
    ru: "*Цена покупки включает выбранные опции и доставку, но не включает налоги, регистрацию и оформление.",
  },

  next: { en: "NEXT", tr: "İLERİ", ru: "ДАЛЕЕ" },
  prev: { en: "BACK", tr: "GERİ", ru: "НАЗАД" },
  button_pdf: { en: "SEND ME PDF", tr: "PDF GÖNDER", ru: "ОТПРАВИТЬ МНЕ PDF" },
  button_buy: { en: "BUY NOW", tr: "HEMEN SATIN AL", ru: "КУПИТЬ СЕЙЧАС" },
  footer_purchase_price: {
    en: "Options Price",
    tr: "Opsiyonların Toplam Fiyatı",
    ru: "Цена опций",
  },
  footer_estimate_payment: {
    en: "Estimate Payment",
    tr: "Tahmini Ödeme",
    ru: "Ориентировочная оплата",
  },
  footer_estimate_delivery: {
    en: "Estimate Delivery<br />6-8 Weeks",
    tr: "Tahmini Teslim Süresi<br />6-8 Hafta",
    ru: "Ориентировочная доставка<br />6-8 недель",
  },
  summary_title: {
    en: "Your [model] is ready to go!",
    tr: "[model] hazır!",
    ru: "Ваш [model] готов!",
  },
  summary_standards: {
    en: "STANDARDS",
    tr: "STANDART DONANIM",
    ru: "СТАНДАРТНОЕ ОСНАЩЕНИЕ",
  },
  summary_upgrade: {
    en: "UPGRADES & OPTIONS",
    tr: "EKLENTİLER VE SEÇENEKLER",
    ru: "ОБНОВЛЕНИЯ И ОПЦИИ",
  },

  form_details: {
    en: "My Details",
    tr: "Kişisel Bilgilerim",
    ru: "Мои данные",
  },
  form_first_name: {
    en: "First Name",
    tr: "İsim",
    ru: "Имя",
  },
  form_last_name: {
    en: "Last Name",
    tr: "Soyisim",
    ru: "Фамилия",
  },
  form_email: {
    en: "Email Address",
    tr: "E-Posta Adresi",
    ru: "Адрес электронной почты",
  },
  form_phone: {
    en: "Phone Number",
    tr: "Telefon Numarası",
    ru: "Номер телефона",
  },
  form_boating: {
    en: "Where are you boating?",
    tr: "Seyir yaptığınız yer?",
    ru: "Где вы катаетесь на лодке?",
  },
};
